import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { CrudGenericsService } from '../common/crud-generics';
import { Environment, ArticoliMacchineComponenti } from '../../models/-index';
import { Observable } from 'rxjs';

@Injectable()
export class ArticoliMacchineComponentiService extends CrudGenericsService<ArticoliMacchineComponenti, number> {
  private base: string;

  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/ArticoliMacchineComponenti`);
    this.base = `${env.apiUrl}/api/ArticoliMacchineComponenti/`;
  }

  GetArtMacCom_ByArticolo(id: number): Observable<ArticoliMacchineComponenti[]> {
    const u = `${this.base}GetArtMacCom_ByArticolo?id=${id}`;
    return this.http.get<ArticoliMacchineComponenti[]>(u);
  }
}
